<template>
  <div class="sample-container">
    <div class="excel-header">
      <div class="excel-icon">X</div>
      <div>
        <h2>Образец XLSX файла</h2>
      </div>
    </div>



    <div class="table-wrapper">
      <table class="sample-table">
        <thead>
        <tr>
          <th>Ссылка</th>
          <th>Город</th>
          <th>Адрес</th>
          <th>Название</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <a href="#" class="link-example" onclick="return false;">
             example.com/1
            </a>
          </td>
          <td>Москва</td>
          <td>ул. Тверская, д. 1</td>
          <td>Тверская 1</td>
        </tr>
        </tbody>
      </table>
          <div class="file-info">
      <span><i>📊</i> Формат: XLSX (Excel)</span>
      <span><i>📝</i> Заголовки: 4 колонки</span>
      <span><i>📄</i> Размер: ~100 KB</span>
    </div>
    </div>


  </div>

</template>

<script>

export default {
  name: 'ExelExample',

}

</script>
<style scoped lang="scss">

.sample-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  max-width: 800px;
  border: 1px solid #ccc;
  transition: transform 0.3s ease;
  margin-top: 10px;
}

.excel-header {
  background: linear-gradient(135deg, #1e6f3f 0%, #2e7d32 100%);
  color: white;
  padding: 5px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.excel-icon {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: #1e6f3f;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.excel-header h2 {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
}

.excel-header p {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
}

.file-info {
  background: #f8f9fa;
  padding: 5px;
  border-bottom: 2px solid #e9ecef;
  display: flex;
  gap: 25px;
  font-size: 0.9rem;
  color: #495057;
}

.file-info span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-info i {
  color: #28a745;
  font-weight: bold;
}

.table-wrapper {
  overflow-x: auto;
}

.sample-table {
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.sample-table thead {
  background: linear-gradient(135deg, #1e6f3f 0%, #2e7d32 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.sample-table th {
  padding: 5px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.sample-table th:last-child {
  border-right: none;
}

.sample-table tbody tr {
  background: white;
  transition: background 0.3s ease;
}

.sample-table tbody tr:hover {
  background: #f8f9ff;
}

.sample-table td {
  padding: 5px;
  border-bottom: 1px solid #e9ecef;
  color: #2c3e50;
  font-size: 0.95rem;
}

.sample-table td:first-child {
  font-weight: 500;
  color: #3498db;
}

.link-example {
  color: #3498db;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.link-example:hover {
  text-decoration: underline;
}


@media (max-width: 600px) {
  .excel-header {
    flex-direction: column;
    text-align: center;
  }

  .file-info {
    flex-direction: column;
    gap: 10px;
  }

  .sample-table th,
  .sample-table td {
    padding: 12px 15px;
    font-size: 0.9rem;
  }

}
</style>

